import { RouteItem } from '@eastcoal/router/types/route'

import { MEMBER_DEFAULT_RESOURCE_PAGE_PATH } from './constants/path'
import {
  MEMBER_DEFAULT_RESOURCE_ACTION_UUID,
  MEMBER_DEFAULT_RESOURCE_PAGE_UUID
} from './constants/uuid'

export const memberDefaultResourceRoute: RouteItem = {
  title: '会员资源',
  path: MEMBER_DEFAULT_RESOURCE_PAGE_PATH,
  uuid: MEMBER_DEFAULT_RESOURCE_PAGE_UUID,
  hideChildrenInMenu: true,
  Component: () => import('./index'),
  children: [
    {
      title: '管理默认资源',
      uuid: MEMBER_DEFAULT_RESOURCE_ACTION_UUID
    }
  ]
}
